const addressUrl = 'https://api.dataforsyningen.dk/adresser'

function getSearchUrl(addressTerm: string): string {
	const url = new URL(addressUrl)
	url.searchParams.set('autocomplete', 'true')
	url.searchParams.set('per_side', '8')
	url.searchParams.set('q', addressTerm)
	return url.toString()
}

export async function addressSearch(
	signal: AbortSignal,
	addressTerm?: string,
): Promise<AutocompletedAddress[]> {
	if (!addressTerm) return []
	try {
		const response = await fetch(getSearchUrl(addressTerm), {
			signal,
		})
		const address = await response.json()
		if (!Array.isArray(address)) {
			const errorMessage = new Error(
				`Address search returned non-array: ${JSON.stringify(address)}`,
			)
			return []
		}
		return address as AutocompletedAddress[]
	} catch (error) {
		return []
	}
}

export interface AutocompletedAddress {
	id: string
	status: number
	darstatus: number
	vejkode: string
	vejnavn: string
	adresseringsvejnavn: string
	husnr: string
	etage: string
	dør: string
	supplerendebynavn: string
	postnr: string
	postnrnavn: string
	stormodtagerpostnr: string
	stormodtagerpostnrnavn: string
	kommunekode: string
	adgangsadresseid: string
	x: number
	y: number
	href: string
	betegnelse: string
}
